import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinkharadi() {

const cardData = {
keyword: "Urbania on Rent in Kharadi",
headingDescription: "Urbania on Rent in Kharadi is a convenient group transportation option for corporate travel, family trips, weddings, airport transfers, employee movement, outstation journeys, and special events. Ruturaj Enterprises provides spacious Urbania vehicles with comfortable seating, air conditioning options, professional driver assistance, and flexible travel arrangements. Whether the pickup is from Kharadi, EON IT Park, World Trade Center, Viman Nagar, Pune Airport, Yerwada, or nearby areas, an Urbania can help groups travel together in a comfortable and organized manner.",
topPlaces: [
{
title: "EON IT Park Kharadi",
description: "EON IT Park is one of the most prominent corporate destinations in Kharadi, with employees and business visitors travelling throughout the day. Urbania rental can be arranged for corporate events, employee group transportation, team outings, airport transfers, and business travel from this important IT hub."
},
{
title: "World Trade Center Kharadi",
description: "World Trade Center Kharadi is a major commercial and business destination where companies frequently require organized group transportation. An Urbania can be useful for corporate meetings, conferences, client visits, employee events, airport transfers, and group travel between offices and hotels."
},
{
title: "Viman Nagar",
description: "Viman Nagar is located close to Kharadi and Pune International Airport, making it a useful destination for both corporate and personal group transportation. Urbania services can support family travel, airport transfers, corporate events, weddings, and outstation journeys from Kharadi."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important pickup and drop destination for Kharadi residents, employees, and business visitors. A spacious Urbania can accommodate groups with luggage and provide coordinated airport transfers between Kharadi, the airport, hotels, offices, and event venues."
},
{
title: "Yerwada",
description: "Yerwada provides convenient connectivity between Kharadi, Pune Airport, Viman Nagar, and central Pune. Urbania transportation from Kharadi to Yerwada and surrounding areas can be useful for corporate groups, family functions, airport travel, and organized local or outstation journeys."
},
{
title: "Kalyani Nagar",
description: "Kalyani Nagar is a well-connected residential and commercial area near Kharadi and Pune Airport. Urbania hire can be arranged for group travel between Kharadi and Kalyani Nagar, including corporate meetings, hotel transfers, family functions, events, and airport transportation."
},
{
title: "Hadapsar",
description: "Hadapsar is an important business and residential area connected to Kharadi through major city routes. Groups can use Urbania transportation between Kharadi and Hadapsar for employee travel, corporate programs, family trips, weddings, sightseeing, and longer outstation journeys."
},
{
title: "Magarpatta City",
description: "Magarpatta City is a major business and residential hub close to Kharadi. Urbania services can support employee transportation, company events, business travel, group transfers, airport pickups, and family journeys connecting Magarpatta with Kharadi and other Pune destinations."
},
{
title: "Wagholi",
description: "Wagholi is located along the eastern Pune corridor and is well connected with Kharadi. An Urbania can be arranged for group transportation between Wagholi and Kharadi for family travel, corporate events, weddings, airport transfers, and outstation trips."
},
{
title: "Mundhwa",
description: "Mundhwa provides connectivity between Kharadi, Hadapsar, Koregaon Park, and other eastern Pune areas. Urbania hire can be useful for corporate teams, families, event groups, airport passengers, and tourists travelling together from the Kharadi region."
}
],
services: [
{
name: "Urbania on Rent in Kharadi",
description: "Urbania on Rent in Kharadi provides a spacious group transportation solution for families, corporate teams, event groups, tourists, and employees. It can be arranged for local travel, airport transfers, weddings, corporate programs, sightseeing, and outstation journeys."
},
{
name: "13 Seater Urbania on Rent in Kharadi",
description: "13 Seater Urbania on Rent in Kharadi is suitable for medium-sized groups looking for comfortable transportation. It can be used for corporate travel, family trips, weddings, airport pickups, team outings, sightseeing, and outstation journeys from Kharadi."
},
{
name: "17 Seater Urbania on Rent in Kharadi",
description: "17 Seater Urbania on Rent in Kharadi is useful when a larger group needs to travel together. The spacious vehicle can support corporate teams, families, event participants, wedding guests, school groups, and tour parties travelling locally or to outstation destinations."
},
{
name: "Urbania Hire in Kharadi Pune",
description: "Urbania Hire in Kharadi Pune offers a convenient option for customers planning group transportation from Kharadi and nearby areas. Professional driver support and spacious seating make it suitable for business travel, family functions, events, airport transfers, and long-distance journeys."
},
{
name: "Urbania Booking in Kharadi",
description: "Urbania Booking in Kharadi allows customers to plan their group transportation around their preferred date, pickup location, destination, and itinerary. Advance arrangements can be useful for weddings, corporate events, family holidays, airport transfers, and outstation tours."
},
{
name: "Luxury Urbania on Rent in Kharadi",
description: "Luxury Urbania on Rent in Kharadi provides a premium group travel option for customers looking for a comfortable vehicle for special occasions and longer journeys. It is suitable for corporate events, executive travel, weddings, family celebrations, and organized tours."
},
{
name: "Urbania Rental Service in Kharadi",
description: "Urbania Rental Service in Kharadi provides flexible group transportation for local and outstation requirements. Customers can use the service for employee travel, family trips, corporate events, weddings, airport transfers, sightseeing, and other planned group journeys."
},
{
name: "AC Urbania on Rent in Kharadi",
description: "AC Urbania on Rent in Kharadi is suitable for passengers who prefer an air-conditioned and comfortable environment during their journey. It can be arranged for corporate travel, family holidays, weddings, airport transfers, sightseeing, and longer outstation routes."
},
{
name: "Non-AC Urbania on Rent in Kharadi",
description: "Non-AC Urbania on Rent in Kharadi provides an alternative group transportation option for customers who do not require air conditioning. It can be useful for local events, group travel, family functions, school programs, and selected outstation requirements."
},
{
name: "Urbania on Rent for Outstation in Kharadi",
description: "Urbania on Rent for Outstation in Kharadi is designed for groups travelling from Kharadi to other cities, tourist destinations, pilgrimage locations, and nearby states. The spacious vehicle allows passengers to travel together with professional driver assistance."
},
{
name: "Urbania for Corporate Events in Kharadi",
description: "Urbania for Corporate Events in Kharadi is suitable for conferences, seminars, meetings, employee outings, annual functions, exhibitions, and business gatherings. A dedicated Urbania can transport employees, clients, and guests between offices, hotels, and event venues."
},
{
name: "Urbania for Airport Pickup Kharadi",
description: "Urbania for Airport Pickup Kharadi provides convenient group transportation to collect multiple passengers from Pune International Airport. The larger vehicle can accommodate passengers and luggage while keeping corporate teams, families, or event groups together."
},
{
name: "Urbania for Wedding Function Kharadi",
description: "Urbania for Wedding Function Kharadi can be arranged to transport family members, relatives, guests, and event participants between homes, hotels, wedding venues, and reception locations. Group transportation helps simplify movement during busy wedding schedules."
},
{
name: "Best Urbania Rental in Kharadi",
description: "Best Urbania Rental in Kharadi is a search term for customers looking for a suitable group vehicle with comfortable seating, professional driver support, and flexible travel arrangements. The service can be used for corporate, family, wedding, airport, and outstation travel."
},
{
name: "Urbania Tempo Traveller in Kharadi",
description: "Urbania Tempo Traveller in Kharadi is suitable for families, corporate groups, tourists, and event participants requiring spacious group transportation. It can be arranged for sightseeing, airport transfers, weddings, business travel, and longer journeys from Kharadi."
},
{
name: "Urbania on Rent Near EON IT Park",
description: "Urbania on Rent Near EON IT Park is convenient for employees and companies arranging transportation close to Kharadi's major IT business hub. It can support office events, team outings, employee travel, client movement, conferences, and airport transfers."
},
{
name: "Urbania on Rent Near World Trade Center Kharadi",
description: "Urbania on Rent Near World Trade Center Kharadi provides a convenient group transportation option for business visitors, employees, clients, and corporate event participants. It can be used for meetings, conferences, airport transfers, hotel movement, and corporate travel."
},
{
name: "Urbania on Rent in Kharadi for Family Trip",
description: "Urbania on Rent in Kharadi for Family Trip is suitable for families travelling together for holidays, weddings, religious visits, sightseeing, and special functions. A spacious vehicle helps keep family members together while making travel coordination easier."
},
{
name: "Urbania on Rent for Group Travel in Kharadi",
description: "Urbania on Rent for Group Travel in Kharadi provides a practical solution for friends, families, corporate teams, tourists, and event groups. It can be used for both local Pune transportation and longer outstation journeys with a planned itinerary."
},
{
name: "Affordable Urbania on Rent in Kharadi",
description: "Affordable Urbania on Rent in Kharadi is suitable for customers seeking a practical larger vehicle for group travel while managing their transportation budget. It can be arranged for family trips, corporate events, weddings, airport transfers, and outstation travel."
},
{
name: "Urbania Traveller Kharadi",
description: "Urbania Traveller Kharadi provides spacious transportation for groups starting from or travelling through Kharadi. It can support corporate travel, family holidays, wedding transportation, airport pickups, sightseeing, and intercity group journeys."
},
{
name: "Urbania on Rent Viman Nagar",
description: "Urbania on Rent Viman Nagar is useful for customers travelling between Kharadi and Viman Nagar or starting their journey from the airport-connected locality. It can be arranged for family groups, corporate teams, airport transfers, events, and outstation trips."
},
{
name: "Urbania on Rent Near Pune Airport",
description: "Urbania on Rent Near Pune Airport is suitable for larger groups requiring convenient transportation to or from Pune International Airport. It provides sufficient space for passengers and luggage and can connect airport travellers with Kharadi, hotels, offices, residences, and event venues."
},
{
name: "Urbania on Rent Yerwada",
description: "Urbania on Rent Yerwada provides group transportation between Yerwada, Kharadi, Pune Airport, and other nearby areas. It can be useful for corporate travel, airport transfers, family functions, weddings, sightseeing, and outstation journeys."
}
],
tableData: [
["Urbania on Rent in Kharadi"],
["13 Seater Urbania on Rent in Kharadi"],
["17 Seater Urbania on Rent in Kharadi"],
["Urbania Hire in Kharadi Pune"],
["Urbania Booking in Kharadi"],
["Luxury Urbania on Rent in Kharadi"],
["Urbania Rental Service in Kharadi"],
["AC Urbania on Rent in Kharadi"],
["Non-AC Urbania on Rent in Kharadi"],
["Urbania on Rent for Outstation in Kharadi"],
["Urbania for Corporate Events in Kharadi"],
["Urbania for Airport Pickup Kharadi"],
["Urbania for Wedding Function Kharadi"],
["Best Urbania Rental in Kharadi"],
["Urbania Tempo Traveller in Kharadi"],
["Urbania on Rent Near EON IT Park"],
["Urbania on Rent Near World Trade Center Kharadi"],
["Urbania on Rent in Kharadi for Family Trip"],
["Urbania on Rent for Group Travel in Kharadi"],
["Affordable Urbania on Rent in Kharadi"],
["Urbania Traveller Kharadi"],
["Urbania on Rent Viman Nagar"],
["Urbania on Rent Near Pune Airport"],
["Urbania on Rent Yerwada"]
],
whychoose: [
{
WhyChooseheading: "Spacious Vehicles for Kharadi Group Travel",
WhyChoosedescription: "Urbania vehicles provide a practical transportation solution when families, employees, business visitors, or event groups need to travel together. The larger seating capacity can reduce the need for coordinating several separate cars."
},
{
WhyChooseheading: "Convenient for EON IT Park and WTC",
WhyChoosedescription: "Kharadi's major business destinations generate regular requirements for employee movement, meetings, corporate events, and guest transportation. Urbania services can be arranged around EON IT Park, World Trade Center, and nearby business locations."
},
{
WhyChooseheading: "Suitable for Corporate Events",
WhyChoosedescription: "Companies can arrange Urbania transportation for conferences, seminars, team outings, annual functions, exhibitions, and business meetings. A dedicated vehicle makes it easier to coordinate employees, clients, and guests between offices, hotels, airports, and event venues."
},
{
WhyChooseheading: "Comfortable Family and Group Travel",
WhyChoosedescription: "Families and groups can travel together for holidays, weddings, religious trips, sightseeing, and special functions. A spacious Urbania provides a convenient shared transportation option while keeping the entire group on a common itinerary."
},
{
WhyChooseheading: "Airport Transfer Convenience",
WhyChoosedescription: "Kharadi is close to Pune International Airport, making airport transportation an important requirement for residents and business travellers. Urbania vehicles can accommodate multiple passengers and luggage for coordinated airport pickup and drop arrangements."
},
{
WhyChooseheading: "Local and Outstation Flexibility",
WhyChoosedescription: "The service can be used for short journeys around Kharadi and Pune as well as longer outstation travel. This flexibility makes Urbania suitable for corporate trips, family holidays, weddings, pilgrimage tours, sightseeing, and multi-city group journeys."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "A dedicated professional driver can make group travel more convenient, particularly when the journey includes several pickup points or unfamiliar destinations. Passengers can focus on their business, family plans, or event activities while the transportation is handled by the driver."
},
{
WhyChooseheading: "Pickup Options Around Eastern Pune",
WhyChoosedescription: "Ruturaj Enterprises can arrange Urbania transportation around Kharadi and nearby locations such as EON IT Park, World Trade Center, Viman Nagar, Pune Airport, Yerwada, Kalyani Nagar, Hadapsar, Magarpatta City, Wagholi, and Mundhwa, depending on the travel requirement."
}
]
};















const faqData = [
{
question: "How can I hire an Urbania on rent in Kharadi?",
answer: "Customers can enquire about Urbania rental in Kharadi by sharing the pickup location, travel date, destination, passenger count, trip duration, and planned itinerary. Ruturaj Enterprises can arrange suitable group transportation for family trips, corporate travel, weddings, sightseeing programs, airport transfers, and outstation journeys."
},
{
question: "Who can rent an Urbania in Kharadi?",
answer: "Families, corporate teams, wedding groups, schools, colleges, tour groups, and other organizations can enquire about an Urbania in Kharadi. It is useful when several passengers need to travel together for a planned local journey, event, tour, or outstation trip."
},
{
question: "Can I hire an Urbania from Kharadi for an outstation trip?",
answer: "An Urbania can be considered for group journeys from Kharadi to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, Aurangabad, and other locations. One-way, return, and multi-day travel requirements can be discussed according to the group's route and schedule."
},
{
question: "Can Urbania on rent in Kharadi be used for corporate employee transportation?",
answer: "Companies located around Kharadi can enquire about Urbania rental for employee outings, business events, training programs, conferences, team activities, and group transportation. Pickup points, office locations, reporting times, passenger count, and destinations can be shared to plan the vehicle according to the corporate schedule."
},
{
question: "Is Urbania suitable for wedding transportation from Kharadi?",
answer: "Wedding families can arrange an Urbania from Kharadi for transporting relatives and guests between homes, hotels, wedding venues, reception halls, railway stations, and airports. The larger group vehicle can help coordinate guest movement when several people need to follow the same wedding itinerary."
},
{
question: "Can I book an Urbania from Kharadi for airport transfers?",
answer: "An Urbania can be useful for group airport transfers from Kharadi to Pune Airport or for returning passengers to the Kharadi area. Customers can provide flight timings, passenger count, luggage requirements, pickup address, and preferred reporting time when discussing the airport transportation requirement."
},
{
question: "Can families hire an Urbania in Kharadi for sightseeing?",
answer: "Families and tour groups can enquire about Urbania rental from Kharadi for sightseeing trips and day tours. The itinerary can include multiple attractions, meal stops, hotel pickups, and return travel, allowing the complete group to follow the planned schedule in one vehicle."
},
{
question: "Can schools and colleges rent an Urbania from Kharadi?",
answer: "Educational groups can consider an Urbania for picnics, educational visits, excursions, industrial tours, and recreational programs starting from Kharadi. Details such as student count, pickup point, destination, travel date, and trip duration can be provided while planning the group transportation."
},
{
question: "Can Urbania be hired from Kharadi for corporate events and conferences?",
answer: "Companies organizing conferences, seminars, exhibitions, workshops, and corporate gatherings can enquire about Urbania transportation for employees, delegates, or visiting guests. Hotel transfers, office pickups, venue transportation, and return journeys can be planned around the event schedule."
},
{
question: "What details are needed to book an Urbania on rent in Kharadi?",
answer: "Customers can provide the pickup address in Kharadi, destination, travel date, passenger count, rental duration, route, and expected return time. Additional details about multiple stops, airport transfers, hotel pickups, wedding functions, corporate events, or sightseeing requirements can also be shared with Ruturaj Enterprises."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Manish Bhandari",
feedback:
"Our group of friends was planning a weekend trip from Kharadi to Lonavala, and we wanted everyone to travel together. We hired an Urbania from Ruturaj Enterprises and shared our pickup and return schedule in advance. Having one vehicle for the entire group made the trip much easier to coordinate.",
rating: 5
},
{
id: 2,
name: "Miss. Rutuja Pawar",
feedback:
"We needed group transportation from Kharadi for a family wedding function with guests staying at different locations. Ruturaj Enterprises arranged an Urbania for the scheduled transfers between the hotel and venue. The larger vehicle helped us move the guests together and keep the event transportation organized.",
rating: 5
}
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Kharadi",
  "image": "https://ruturajenterprises.com/assets/images/urbania-on-rent-in-kharadi.webp",
  "description": "Urbania on Rent in Kharadi from Ruturaj Enterprises is a spacious group transportation option for families, corporate teams, wedding groups, airport travellers and customers planning local or outstation journeys from the Kharadi area. 13 Seater Urbania on Rent in Kharadi and 17 Seater Urbania on Rent in Kharadi are suitable for different group sizes, offering comfortable seating and practical space for luggage. Urbania Hire in Kharadi Pune and Urbania Booking in Kharadi can be arranged for planned trips, events, sightseeing and business travel. Luxury Urbania on Rent in Kharadi and AC Urbania on Rent in Kharadi are suitable for passengers looking for a more comfortable travel experience, while Non-AC Urbania on Rent in Kharadi provides another option for group transportation. Urbania Rental Service in Kharadi can support outstation journeys, corporate events, airport transfers, weddings and family trips. Urbania on Rent for Outstation in Kharadi is suitable for longer routes, while Urbania for Corporate Events in Kharadi and Urbania for Wedding Function Kharadi can be arranged for organized group movement. Urbania for Airport Pickup Kharadi is convenient for passengers travelling to and from Pune Airport. Customers can also choose Urbania on Rent Near EON IT Park and Urbania on Rent Near World Trade Center Kharadi for convenient corporate pickups. Urbania on Rent in Kharadi for Family Trip and Urbania on Rent for Group Travel in Kharadi are suitable for vacations, pilgrimages and group tours. Affordable Urbania on Rent in Kharadi, Urbania Traveller Kharadi, Urbania on Rent Viman Nagar, Urbania on Rent Near Pune Airport and Urbania on Rent Yerwada provide additional pickup and travel options around the eastern Pune region.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-on-rent-in-kharadi"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Urbania on Rent in Kharadi | 13 & 17 Seater Luxury Traveller for Local & Outstation Trips | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania on Rent in Kharadi by Ruturaj Enterprises for 13 and 17 seater group travel, corporate events, airport pickup, weddings, family trips, outstation journeys and travel near EON IT Park."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Kharadi, 13 Seater Urbania on Rent in Kharadi, 17 Seater Urbania on Rent in Kharadi, Urbania Hire in Kharadi Pune, Urbania Booking in Kharadi, Luxury Urbania on Rent in Kharadi, Urbania Rental Service in Kharadi, AC Urbania on Rent in Kharadi, Non-AC Urbania on Rent in Kharadi, Urbania on Rent for Outstation in Kharadi, Urbania for Corporate Events in Kharadi, Urbania for Airport Pickup Kharadi, Urbania for Wedding Function Kharadi, Best Urbania Rental in Kharadi, Urbania Tempo Traveller in Kharadi, Urbania on Rent Near EON IT Park, Urbania on Rent Near World Trade Center Kharadi, Urbania on Rent in Kharadi for Family Trip, Urbania on Rent for Group Travel in Kharadi, Affordable Urbania on Rent in Kharadi, Urbania Traveller Kharadi, Urbania on Rent Viman Nagar, Urbania on Rent Near Pune Airport, Urbania on Rent Yerwada, Urbania with Driver Kharadi, Urbania Cab Kharadi, Urbania Traveller Rental Kharadi, 13 Seater Urbania Kharadi, 17 Seater Urbania Kharadi, Urbania for Corporate Travel Kharadi, Urbania for Office Travel Kharadi, Urbania for Business Events Kharadi, Urbania Airport Transfer Kharadi, Urbania for Family Tour Kharadi, Urbania for Wedding Guests Kharadi, Urbania Outstation Rental Kharadi, Pune Airport Urbania Rental, Kharadi Urbania Rental Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinkharadi;